import { apiClient } from '../../api/client';

/** Линия, через которую рабочее место звонит по умолчанию. */
export interface WorkplaceLine {
  id: number;
  name: string;
  number: string | null;
  active: boolean;
}

/**
 * Всё, что браузеру нужно, чтобы стать SIP-точкой. Пароль приходит в открытом
 * виде — иначе зарегистрироваться нечем; поэтому он живёт только в памяти
 * вкладки: ни в кэше запросов, ни в localStorage его нет.
 */
export interface WorkplaceCredentials {
  username: string;
  password: string;
  sip_domain: string;
  ws_url: string;
  display_name: string;
  check_number: string;
  line: WorkplaceLine | null;
  /**
   * Перевалочные адреса для голоса с временным паролем. Пустой список —
   * законное состояние: значит звоним напрямую, как раньше.
   */
  ice_servers: RTCIceServer[];
}

/**
 * Учётка запрашивается не при открытии экрана, а по кнопке «Подключиться»:
 * открыл страницу посмотреть — пароль по сети не поехал. Поэтому обычная
 * функция, а не useQuery: кэш пароля нам не нужен ни на секунду.
 */
export async function fetchWorkplaceCredentials(): Promise<WorkplaceCredentials> {
  const { data } = await apiClient.get<WorkplaceCredentials>('/telephony/workplace/credentials');

  return data;
}

/**
 * Отправить журнал проверки на сервер.
 *
 * Разбор немого звонка не должен упираться в то, скопирует ли человек текст
 * с экрана: страница знает всё нужное и отдаёт это сама. Ошибку отправки
 * глушим — проверка слышимости важнее, чем её отчёт.
 */
export async function sendWorkplaceDiagnostics(lines: string[], outcome: string): Promise<void> {
  try {
    await apiClient.post('/telephony/workplace/diagnostics', { lines: lines.slice(0, 80), outcome });
  } catch {
    // Молча: не мешаем человеку звонить из-за неотправленного отчёта.
  }
}
